import { render, staticRenderFns } from "./PurchaseOrderAddressSelect.vue?vue&type=template&id=60cbb16a&"
import script from "./PurchaseOrderAddressSelect.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderAddressSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports